module.exports = __webpack_public_path__ + "static/img/img6.c54ca01.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qmyd/qgz/img6.jpeg
// module id = /nbG
// module chunks = 46